import SectionHeader from '../common/SectionHeader';

function CapabilitySection({ section }) {
  return (
    <article className="service-capability">
      <h3>{section.title}</h3>
      {section.description && <p>{section.description}</p>}
      {section.items && (
        <div className="service-capability__items">
          {section.items.map((item) => (
            <span key={item}>{item}</span>
          ))}
        </div>
      )}
    </article>
  );
}

function FeatureGrid({ capabilitySections = [], features = [] }) {
  return (
    <section className="service-section">
      <div className="container">
        <SectionHeader
          eyebrow="Core Capabilities"
          title="Product and operating capabilities"
          description="The page focuses on what the project can do today and how those capabilities can support future business growth."
        />

        {capabilitySections.length > 0 && (
          <div className="service-capability-grid">
            {capabilitySections.map((section) => (
              <CapabilitySection key={section.title} section={section} />
            ))}
          </div>
        )}

        {features.length > 0 && (
          <div className="service-feature-grid">
            {features.map((feature) => (
              <article className="service-feature-card" key={feature}>
                <span aria-hidden="true" />
                <h3>{feature}</h3>
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}

export default FeatureGrid;
